import React, { useState, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useSiteViewModel } from '../ViewModel/SiteViewModel';
import { UserResponse } from '../Model/User';
import { useAuthViewModel } from '../ViewModel/AuthViewModel';
// import ConnectionStatusWidget from './ConnectionStatusWidget';
// import { useConnectionStatus } from './ConnectionStatusProvider';
import { DeploymentTrackerProvider } from './DeploymentTrackerContext';
import DeploymentMonitorInitializer from './DeploymentMonitorInitializer';
import DeploymentMonitor from './DeploymentMonitor';
import { UserProvider } from '../Core/UserContext';
// import AWSSetupModal from './AwsConnection';

const ProtectedLayoutContent: React.FC = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  const { dashboardData } = useSiteViewModel();
  const { logout, checkAuthentication } = useAuthViewModel();
  // const { showAWSModal, setShowAWSModal, checkConnectionStatus } = useConnectionStatus();
  const [userData, setUserData] = useState<UserResponse | null | undefined>(undefined);
  const isAuthenticated = checkAuthentication();

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      const data = await dashboardData();
      setUserData(data ?? undefined);
    };
    fetchUserData();
  }, [dashboardData]);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
     <UserProvider user={userData ?? null}>
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: '#09090e' }}>
          <Sidebar user={userData} logout={logout} />

          {/* Main content — offset by sidebar width on desktop */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              background: '#09090e',
              marginLeft: isDesktop ? '220px' : '0',      // ← matches new sidebar width
              paddingTop: isDesktop ? '0' : '52px',        // ← mobile header height
            }}
          >
            <main style={{ flexGrow: 1, overflowY: 'auto' }}>
              <Outlet />
            </main>
            {/* <ConnectionStatusWidget /> */}
            <DeploymentMonitor />
            <DeploymentMonitorInitializer />
          </div>

          {/* <AWSSetupModal
            open={showAWSModal}
            onClose={() => setShowAWSModal(false)}
            onSuccess={async () => {
              setShowAWSModal(false);
              await checkConnectionStatus();
            }}
            externalId={userData?.external_id || ''}
          /> */}
        </div>
    </UserProvider>
  );
};

const ProtectedLayout: React.FC = () => {
  return (
    <>
      <DeploymentTrackerProvider>
        <ProtectedLayoutContent />
      </DeploymentTrackerProvider>
    </>
  );
};

export default ProtectedLayout;